import BillingTransactionsService from 'js/services/api/billing/transactions.js'
import PassengerTnesService from 'js/services/api/passenger/tnes.js'

import MediaPanelsCommonMixin from '../_media_panels_common_mixin'
import TransactionsMixin from '../_transactions_mixin.js'
import DeregisterTne from './_deregister-tne'

import TneItem from './_tne-item.js'
import Transaction from './_transaction.js'

import template from './index.pug'

const QR_ID_MEDIA_TYPE = '2'
const TNE_MEDIA_TYPE = '4'
const REGISTERED = 1

// @vue/component
export default {
  template: template(),
  components: {
    TneItem,
    Transaction,
    DeregisterTne
  },
  mixins: [
    MediaPanelsCommonMixin,
    TransactionsMixin
  ],
  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tnes: [],
      transactions: [],
      tneDeregistering: null,
      pendingAmount: null, // Saldo pendiente Everilion
      pagination: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      }
    }
  },
  computed: {
    balance() {
      return this.getBalance(this.account)
    },

    mediaTypes() {
      return [QR_ID_MEDIA_TYPE, TNE_MEDIA_TYPE]
    },

    hasTneMediaType() {
      if (!this.$administrativeArea.media_types) { return false }

      return this.$administrativeArea.media_types.findIndex(
        item => item.code === TNE_MEDIA_TYPE
      ) >= 0
    },

    accountName() {
      if (!this.account.mediaType) { return '' }

      return this.$t(`balance.mediaTypes.${this.account.mediaType}`)
    },

    hasTransactions() {
      return this.transactions && this.transactions.length > 0
    },

    indexTneParams() {
      return {
        administrative_area_id: this.$administrativeArea.id,
        account_id: this.account.account_id,
        per: 0,
        registered: REGISTERED,
        order_by: 'created_at',
        order_dir: 'asc'
      }
    },

    transactionsAmounts() {
      return this.transactions.map(transaction => this.getTransactionAmount(transaction) * -1)
    }
  },

  watch: {
    // Observa cambios en la propiedad $route
    '$route'(newRoute, oldRoute) {
      // Realiza acciones cuando cambia la URL
      // Actualiza tu elemento o realiza otras acciones aquí
      this.getData()
    }
  },

  created() {
    this.getData()
  },

  methods: {
    async getData() {
      this.tnes = await this.getTnes()
      await this.getQrTransactions()
      this.pendingAmount = await this.getPendingAmount(this.account, this.account.mediaType)
    },

    async getTnes() {
      return PassengerTnesService.index(this.indexTneParams).then(response => response.data)
    },

    goToNewTneForm(accountId) {
      this.$router.push({
        name: 'municipality-data-balance-tnes-new',
        params: {id: accountId}
      })
    },

    getQrTransactions() {
      const params = {
        administrative_area_id: this.$administrativeArea.id,
        media_type_array: this.mediaTypes,
        account_client_transactions: true,
        order_by: 'operation_date',
        order_dir: 'desc',
        per: 50
      }

      return BillingTransactionsService.index(params).then(data => {
        this.transactions = this.prepareQrTransactions(data)
        const firstPosition = (this.pagination.currentPage - 1) * this.pagination.limit
        this.pagination.totalElements = this.transactions.length
        this.transactions = this.transactions.slice(
          firstPosition,
          firstPosition + this.pagination.limit
        )
      })
    },

    prepareQrTransactions(transactions) {
      const time_zone = this.$administrativeAreaTimeZone

      if (time_zone) {
        transactions.forEach(transaction => {
          if (transaction.operation_date) {
            const date = moment(transaction.operation_date).tz(time_zone)
            transaction.date = date.format('DD MMM HH:mm').replace('.', '')
          }
        })
      }

      return transactions
    },

    onDeregisterTne(tne) {
      this.tneDeregistering = tne
    },

    onDeregisterTneFinished() {
      this.tneDeregistering = null
    },

    deleteDeregisterTneOfView() {
      this.tnes = this.tnes.filter(tne => tne !== this.tneDeregistering)
    },

    changeLimit(limit) {
      this.pagination.limit = limit
      this.pagination.currentPage = 1
      this.getQrTransactions()
    },

    changePage(page) {
      this.pagination.currentPage = page
      this.getQrTransactions()
    }
  }
}
